module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAArElEQVR4AWOgC3jOIEwkwtQg8pyB/xkDxws+BSB6xsD5nIEPKIhTwzMGnpeSat83bP114szPA0e+LV4F5AIFcWkQfM4j8fvy9Y/ZpW/sPb8tWvbnyTMg9zm3BFAKRQPMePYP6cXfFix/Kaz879v372u3/L549f///x9is4BSWDWwfpk8+0N0+oe47F+nzz9j4f2YUw7U8KWt/xkDC6U2EPYDeaFEeTwQjulBCQCME84IiS7riAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TN.png
// module id = 1283
// module chunks = 0